import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaRulemRmAttachment.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(DOC|PIC|URL)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'DOC'},
                {type: 'PIC'},
                {type: 'URL'},
            ]
        },
    })
}
